<template>
  <div class="adBg" :class="[
    'sidebar',
    collapsed ? 'open-sidebar' : '',
    proList && proList.length > 0 && !isEntMenu && appEnv != 'fgy'
      ? 'no-sidebar'
      : '',
  ]" v-show="$route.path.indexOf('/main') == -1 &&
    $route.path.indexOf('/main/workBench') == -1 &&
    $route.path.indexOf('/main/vehicleScheduling') == -1 &&
    $route.path.indexOf('/main/consumerSafetyIntegration') == -1 &&
    $route.path.indexOf('/main/showAllList') == -1 &&
    $route.path.indexOf('/ifmAsset/narrowLabel') == -1 &&
    $route.path.indexOf('/ifmAsset/wideLabel') == -1 &&
    $route.path.indexOf('/ifmAsset/elevatorSpecialLabel') == -1 &&
    $route.path.indexOf('/serviceAlliance/addService') == -1 &&
    $route.path.indexOf('/serviceAlliance/editService') == -1
    ">
    <div class="project-select-info project-no-select-info"
      v-if="isEntMenu && appEnv != 'fgy' && !$route.path.startsWith('/paymentMerchant')">
      <span>无需项目切换</span>
      <a-icon type="swap" />
    </div>
    <div class="project-select-info project-no-select-info"
      v-if="mchList && mchList.length <= 0 && isEntMenu && $route.path.startsWith('/paymentMerchant')">
      <span>暂无可选商户</span>
      <a-icon type="swap" />
    </div>
    <!-- <div
      v-else
      class="project-select-info"
      @click="handleShowProjectSelect"
      :class="{ 'project-select-more': proList.length > 1 }"
    >
      <project-select
        v-show="proList.length>1 && !isEntMenu"
        :showVisible="showVisible"
        @chooseProject="chooseProject"
        @closeProjectSelect="closeProjectSelect"
      ></project-select>
      <a-tooltip
        v-show="proList.length == 1 && !isEntMenu"
        placement="top"
        overlayClassName="user-name-tooltip"
        :getPopupContainer="
          (triggerNode) => {
            return triggerNode.parentNode || document.body;
          }
        "
      >
        <template slot="title">
          <span class="m-custom-project-name">{{ projectInfo.name }}</span>
        </template>
<span class="project-real-name">{{projectInfo.name}}</span>

</a-tooltip>
</div> -->
    <div class="project-select-info project-no-select-info"
      v-show="proList && proList.length <= 0 && !isEntMenu && !isProjectSearch && !$route.path.startsWith('/paymentMerchant')">
      <span>暂无项目信息</span>
      <a-icon type="swap" />
    </div>
    <a-menu mode="inline" class="sider-menu" :openKeys.sync="openMenu" :selectedKeys="activeMenu"
      :inline-collapsed="collapsed" @click="menuItemClick" v-if="subMenu && subMenu.length > 0 && subMenu.every((i) => i.menuType != 0)
      ">
      <template v-for="item in subMenu">
        <!-- 一级菜单（没有子级） -->
        <a-menu-item v-if="item.children.length === 0 ||
          item.children.every((i) => i.menuType === 0)
        " :key="item.code" @click="handleGoto(item, 0)">

          <IconBox :iconName="item.iconUrl" />
          <span>{{ item.name }}</span>

        </a-menu-item>
        <!-- 一级菜单（有子级） -->
        <Submenu v-else :key="item.code" :list="item" :handleGoto="handleGoto" :handleTitleClick="handleTitleClick"
          :getLocalSvgPath="getLocalSvgPath" />
      </template>
    </a-menu>
    <div class="box-collapsed" :class="{ 'hide-box-collapsed': collapsed }">
      <!-- <div class="collapsed-btn" @click="toggleCollapsed">
        <a-icon v-if="!collapsed" type="menu-fold" class="left-menu-fold" />
        <a-icon v-else type="menu-unfold" class="left-menu-fold" />
      </div> -->
    </div>
    <!-- <a-button class="box-collapsed" :class="{'hide-box-collapsed':collapsed}" type="primary" style="margin-bottom: 16px" @click="toggleCollapsed">
      <a-icon :type="collapsed ? 'menu-unfold' : 'menu-fold'" />
    </a-button> -->
  </div>
</template>

<script>
import { mapState } from "vuex"

import Submenu from "./Submenu.vue"
import SidebarItem from "./SidebarItem.vue"

import SVGBox from "@/components/SVGBox"
import IconBox from "./IconBox"
import { store, event } from "@ice/stark-data"
import { setStore, setSession } from "@/utils/storage.js"
import ProjectSelect from "@/views/new-project-select/IndexThree.vue"
export default {
  name: "Sidebar",
  components: {
    SidebarItem,
    Submenu,
    ProjectSelect,
    SVGBox,
    IconBox,
  },
  data() {
    return {
      showVisible: false,
      collapsed: false,
      openMenu: [],
      copyOpenMenu: [], //新增一个副本数组，用来处理展开、折叠打开的数组(openMenu)的赋值操作
      subCode: sessionStorage.getItem("subCode")
        ? sessionStorage.getItem("subCode")
        : "",
      projectName: "",
      appEnv: "",
    }
  },
  computed: {
    ...mapState([
      "subMenu",
      "activeMenu",
      "projectInfo",
      "isEntMenu",
      "proList",
      "isProjectSearch",
      "folding",
      "mchList"
    ]),
  },
  watch: {
    folding() {
      this.collapsed = this.folding
    },
    $route(to, from) {
      const { path } = to
      event.emit("collapsed", this.collapsed)
      console.log(this.subMenu, 'this.subMenu11')
      this.subMenu.forEach((item) => {
        if (this.hasRoute(item, path)) {
          if (this.subCode) {
            this.openMenu = [item.code, this.subCode]
            this.copyOpenMenu = [item.code, this.subCode]
          } else {
            this.openMenu = [item.code]
            this.copyOpenMenu = [item.code]
          }
        }
      })
    },
  },
  mounted() {
    const { path } = this.$route
    this.initSEvent()
    this.appEnv = process.env.VUE_APP_ENV
    this.subMenu.forEach((item) => {
      if (this.hasRoute(item, path)) {
        if (this.subCode) {
          this.openMenu = [item.code, this.subCode]
          this.copyOpenMenu = [item.code, this.subCode]
        } else {
          this.openMenu = [item.code]
          this.copyOpenMenu = [item.code]
        }
      }
    })
  },
  methods: {
    handleTitleClick(subChild) {
      this.subCode = subChild.code
      sessionStorage.setItem("subCode", subChild.code)
    },
    findParent(menu, item) {
      for (let i = 0; i < menu.length; i++) {
        const ele = menu[i]
        if (ele.level === item.level - 1) {
          if (ele.children.some((i) => i?.menuUrl === item?.menuUrl)) {
            this.$store.commit("SET_ACTIVEMENU", ele.code)
          }
        } else {
          if (ele.children.length > 0) {
            this.findParent(ele.children, item)
          }
        }
      }
    },

    hasRoute(menu, path) {
      for (let i = 0; i < menu.children.length; i++) {
        const element = menu.children[i]
        if (element?.menuUrl === path) {
          if (element.menuType != 0) {
            // this.$store.commit(
            //   "MENU_ENT_TYPE",
            //   element?.type == 3 ? true : false
            // );
            this.$store.commit("SET_ACTIVEMENU", element.code)
          } else {
            this.findParent(this.subMenu, element)
          }
          return true
        } else {
          if (element.children.length > 0) {
            if (this.hasRoute(element, path)) return true
          }
        }
      }
    },

    menuItemClick({ item, key, keyPath }) {
      this.$store.commit("SET_ACTIVEMENU", key)
    },

    handleGoto(item, flag) {
      console.log(item, 'item')
      console.log(flag, 'flag')
      if (item?.type) {
        this.$store.commit("MENU_ENT_TYPE", item?.type == 3 ? true : false)
      }
      // 去掉面包屑默认值
      event.emit("currentBread", "")
      sessionStorage.removeItem("matterActiveKey")
      store.set("extendz", item?.extendz)
      if (item?.extendz) {
        setStore("hwUrl", item?.extendz)
      }
      if (flag != 2) {
        this.subCode = ""
        sessionStorage.removeItem("subCode")
      }
      this.$store.commit("SAVE_CURRENTPATH", item?.menuUrl)
      setSession("currentPath", item?.menuUrl)
      if (item?.menuUrl === this.$route.path) return
      if (item?.menuUrl) window.history.pushState({}, "", item.menuUrl)
    },
    // 点击折叠
    toggleCollapsed() {
      this.collapsed = !this.collapsed
      event.emit("collapsed", this.collapsed)
      if (this.collapsed) {
        //折叠的时候将数组置空操作，展开的时候重新赋值处理
        this.openMenu = []
      } else {
        this.openMenu = this.copyOpenMenu
      }
      this.$store.commit("SET_FOLDING", this.collapsed)
    },
    closeProjectSelect() {
      this.showVisible = false
    },
    initSEvent() { },
    getLocalSvgPath(menu) {
      const baseUrl = process.env.BASE_URL
      const { iconUrl } = menu
      console.log("baseUrl", baseUrl)
      return `${baseUrl}config/icons/${iconUrl || "default"}.svg`
    },
  },
}
</script>

<style lang="less" scoped>
// variables.less

@prefixCls: ~'@{ant-prefix}'; // 使用 @ant-prefix

:deep(.@{prefixCls}-menu-root.sider-menu)>.@{prefixCls}-menu-item {
  margin: 12PX 8PX 0;
}

:deep(.@{prefixCls}-menu) {
  width: auto;
  background: transparent;
  font-size: 14PX;
  color: #FFFFFF;
  line-height: 40px;
  margin: 0;
  width: auto;

  .@{prefixCls}-menu-item {
    margin: 8PX 0;
    width: auto;
    display: flex;
    align-items: center;
  }

  .@{prefixCls}-menu-item.@{prefixCls}-menu-item-selected,
  .@{prefixCls}-menu-item.@{prefixCls}-menu-item-selected:hover {
    color: var(--theme-color);
    padding: 0;
  }

  .sider-item {
    padding-left: 52PX !important;
  }

  .@{prefixCls}-menu-submenu-open.subsub-menu li.sider-item.@{prefixCls}-menu-item {
    padding-left: 68PX !important;
  }

  .@{prefixCls}-menu-submenu {
    padding: 0;
    margin: 0 8PX;
    border-radius: 4PX;
  }

  .@{prefixCls}-menu-submenu.subsub-menu {
    margin: 0;

    .@{prefixCls}-menu-submenu-title {
      padding-left: 52PX !important;
    }
  }



  // .@{prefixCls}-menu-submenu-open
  .@{prefixCls}-menu-submenu {
    .@{prefixCls}-menu-submenu-title {
      background: transparent;

      margin: 8PX 0 0;
      border-radius: 4px;
      display: flex;
      align-items: center;
    }

    .@{prefixCls}-menu {
      background: transparent;
    }
  }

  .@{prefixCls}-menu-submenu-selected.@{prefixCls}-menu-submenu-open {

    >.@{prefixCls}-menu-submenu-title,
    .@{prefixCls}-menu-submenu-open.@{prefixCls}-menu-submenu-selected .@{prefixCls}-menu-submenu-title {
      background: rgba(255, 255, 255, 0.2);
    }
  }

  .@{prefixCls}-menu-submenu-title:active {
    background: transparent;
  }

  .@{prefixCls}-menu-item:hover,
  .@{prefixCls}-menu-submenu-title:hover {
    background: rgba(255, 255, 255, 0.2);
    border-radius: 4PX;
    color: #fff;
  }

  .@{prefixCls}-menu-submenu-title:hover,
  .@{prefixCls}-menu-submenu .@{prefixCls}-menu-submenu-title {
    padding: 0;
    color: #fff;
    padding: 8PX 12PX;

    .@{prefixCls}-menu-submenu-arrow::after,
    .@{prefixCls}-menu-submenu-arrow::before {
      // linear-gradient(to right, #182A4E, #182A4E)
      background-image: none;
      background: #fff;
      color: #fff;

    }
  }

  .@{prefixCls}-menu-item::after {
    border: none;
  }
}

.@{prefixCls}-menu:not(.@{prefixCls}-menu-horizontal) .@{prefixCls}-menu-item-selected {
  background: rgba(255, 255, 255, 0.8);
  border-radius: 4PX;

  .itemTitle {
    color: var(--theme-color);
  }
}


.m-custom-project-name {
  color: #fff;
  word-break: break-all;
}

.sidebar {
  position: fixed;
  left: 0;
  top: 56px;
  width: 226px;
  height: calc(~'100% - 56px');
  padding-bottom: 80px;
  z-index: 18;
  // box-shadow: 0 0px 12px rgba(0, 0, 0, 0.1);
  -webkit-user-select: none;
  /* Safari */
  -moz-user-select: none;
  /* Firefox */
  -ms-user-select: none;
  /* IE10+/Edge */
  user-select: none;

  /* 标准语法 */
  // background: @sidebar-bg-color;
  .box-collapsed {
    width: 226px;
    height: 56px;
    position: fixed;
    // background-color: rgb(246, 225, 254);
    // background-color: red;
    z-index: 1000;
    padding-left: 188px;
    bottom: -5px;
    // border-top: 1px solid #e8e8e8;
    display: flex;
    align-items: center;
  }

  .hide-box-collapsed {
    width: 50px;
    padding-left: 15px;
  }

  .collapsed-btn {
    width: 20px;
    font-size: 22px;
    cursor: pointer;
    color: #000;

    ::v-deep .anticon svg {
      width: 20px !important;
      height: 20px !important;
    }
  }
}

.no-sidebar {
  top: 110px !important;
  height: calc(~'100% - 80px') !important;
}

// .sider-item {
//   height: 48px !important;
//   line-height: 48px !important;
// }

.ant-menu-inline .ant-menu-item::after {
  border-right: none;
}

.open-sidebar {
  width: 225px !important;
}
</style>

<style lang="less">
.sider-menu {
  // background-color: rgb(146, 97, 243) !important;
}

.sidebar {
  overflow-y: auto;
  overflow-x: hidden;
  box-sizing: border-box;

  .house-menu {
    background: #fff;
    // background: @sidebar-bg-color;
    border: none;

    .house-menu-item {
      padding-left: 16px !important;
      display: flex;
      align-items: center;
      height: 48px;
      line-height: 48px;
    }

    .house-menu-submenu {
      padding: 0;

      .house-menu-submenu-title {
        height: 48px;
        line-height: 48px;
        margin: 0;
        color: #262626;
        padding: 0 16px !important;
        display: flex;
        align-items: center;
      }

      // menu子级
      .house-menu-sub {
        background: #fff;

        .house-menu-item {
          padding-left: 50px !important;
        }
      }
    }

    .subsub-menu {
      .house-menu-submenu-title {
        padding: 0 0 0 50px !important;
      }

      .house-menu-sub .house-menu-item {
        padding-left: 70px !important;
        background: #fafafa;
      }

      .house-menu-sub .house-menu-item:hover {
        background: #f0f0f0;
      }
    }
  }

  .house-menu {
    .subsub-menu {
      padding: 0 0 0 0;
      margin-bottom: 0;

      .house-menu-item:first-of-type {
        margin-top: 0;
      }
    }

    .subsub-menu:first-of-type {
      padding-top: 0;
    }
  }

  .menu-worker-icon {
    width: 18px !important;
    height: 18px !important;
  }

  // 菜单子级
  .house-menu-sub {
    .house-menu-item {
      height: 48px;
      padding-left: 76px !important;
      margin: 0;
      border-radius: 0;
    }
  }

  .house-menu-item-selected {
    background: #ebecf0 !important;
  }

  .house-menu-item:after {
    border: none !important;
  }

  .ant-menu-inline .ant-menu-item::after {
    border-right: none !important;
  }

  .ant-menu-submenu>.ant-menu {
    background-color: @sidebar-bg-color;
  }

  .ant-menu-submenu-selected {
    color: #000 !important;
  }
}

.project-select-info {
  position: relative;
  display: flex;
  align-items: center;
  height: 46px;
  padding-left: 24px;
  color: @primary-color;

  .project-real-name {
    width: 127px;
    color: #262626;
    white-space: nowrap;
    font-size: 14px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    -o-text-overflow: ellipsis;
  }
}

// .project-select-more {
//   cursor: pointer;
//   &::after {
//     content: '';
//     position: absolute;
//     right: 10px;
//     margin-left: -7px;
//     z-index: 9;
//     width: 0;
//     height: 0;
//     border-left: 6px solid transparent;
//     border-right: 6px solid transparent;
//     border-top: 7px solid #8c8c8c;
//   }
// }
.project-no-select-info {
  color: #bfbfbf;
  justify-content: space-between;
  padding-left: 16px;
  padding-right: 12px;
  font-weight: 500;
  font-size: 16px;
  border-bottom: 1px solid #f0f0f0;

  span {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    -o-text-overflow: ellipsis;
  }
}
</style>
